import React from "react";
import { confirmAlert } from "react-confirm-alert";
import AppTranslation from "../../../service/app_translation/AppTranslation";

type AlertConfirmType = {
  title: string;
  messsage?: string;
  textCancel?: string;
  textConfirm?: string;
  onCancel?: () => void;
  onConfirm: () => void;
};

type AlertMesageType = {
  buttonWidth?: number;
  title: string;
  messsage?: string;
  textButton?: string;
  onClick?: () => void;
};

export const AlertMesage = ({
  buttonWidth,
  title,
  messsage,
  onClick,
  textButton = AppTranslation.text("ok"),
}: AlertMesageType) => {
  let style: any = { width: 200 };

  if (buttonWidth !== undefined) {
    style = { ...style, width: `${buttonWidth}px` };
  }

  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="alert-wrapper">
        <div className="alert-box text-center font-size-16_17">
          {title !== undefined && (
            <div className="alert-title color-theme-label font-gotham-book pb-2">
              {AppTranslation.text(title)}
            </div>
          )}

          {messsage !== undefined && (
            <div className="alert-message color-theme-label font-gotham-medium pt-1 pb-2">
              {AppTranslation.text(messsage)}
            </div>
          )}

          <div className="pt-4 d-center">
            <div style={style}>
              <button
                className="button-confirm theme-btn bgcolor-primary w-100"
                onClick={() => {
                  if (onClick !== undefined) {
                    onClick!();
                  }
                  onClose();
                }}
              >
                {textButton}
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

export const AlertConfirm = ({
  title,
  messsage,
  onCancel,
  onConfirm,
  textCancel = "cancel",
  textConfirm = "confirm",
}: AlertConfirmType) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="alert-wrapper">
        <div className="alert-box text-center font-size-16_17">
          {title !== undefined && (
            <div className="alert-title color-theme-label font-gotham-book pb-2">
              {AppTranslation.text(title)}
            </div>
          )}

          {messsage !== undefined && (
            <div className="alert-message color-theme-label font-gotham-medium pt-1 pb-2">
              {AppTranslation.text(messsage)}
            </div>
          )}

          <div className="alert-buttons pt-4">
            <button
              className="button-cancel theme-btn bgcolor-primary"
              onClick={() => {
                if (onCancel !== undefined) {
                  onCancel!();
                }

                onClose();
              }}
            >
              {AppTranslation.text(textCancel)}
            </button>
            <button
              className="button-confirm theme-btn bgcolor-primary"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {AppTranslation.text(textConfirm)}
            </button>
          </div>
        </div>
      </div>
    ),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};
